
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Status} from './status';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class StatusService
{

    
    constructor(private http: HttpClient) { 
    }
    
    statusurl = environment.appURL+"/statuses";

 getStatuses() 
{
  
  return this.http.get<Status[]>(this.statusurl,{headers: new HttpHeaders({"Authorization":"Bearer " + environment.token})})
  .pipe(
    tap(_ => {}),
    catchError(this.handleError('getStatuses', []))
  );
}

getStatus(id: number)
{
  const url = `${this.statusurl}/${id}`;

  return this.http.get<Status>( url,{headers: new HttpHeaders({"Authorization":"Bearer " + environment.token})})
  .pipe(
    tap(_ => {}),
    catchError(this.handleError<Status>(`getStatus id=${id}`))
  );
 }


 updateStatus (status: Status): Observable<any> {
   let upd = "status=" + status.status 
  return this.http.put(this.statusurl +"/"+ status.id, upd , {headers: new HttpHeaders({"Authorization":"Bearer " + environment.token, "Content-Type": "application/x-www-form-urlencoded"})})
  .pipe(
    tap(_ => {}),
    catchError(this.handleError<any>('updateStatus'))
  );
}


private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}